export default "__VITE_ASSET__D1IWnAz3__"